import { TStartPackagePayload } from "@elixir/types";
import { GET_TRYST_HOST } from "../constants/env";
import fetch from "../fetch-client";

export default async function postPatientPackageStart({
  data,
}: {
  data: TStartPackagePayload;
}): Promise<{
  success: boolean;
  error?: string;
}> {
  try {
    const TRYST_HOST = GET_TRYST_HOST();
    const headers = new Headers();

    headers.append("accept", "application/json");
    headers.append("Content-Type", "application/json");

    const body = JSON.stringify({
      payload: data,
    });

    const requestOptions: RequestInit = {
      method: "POST",
      body,
      headers,
      credentials: "include",
    };

    const response = await fetch(`${TRYST_HOST}/package/start`, requestOptions);

    const resp = await response.json();
    return resp;
  } catch (error) {
    console.error("ERROR =====> postPatientPackageStart", error);
    return { success: false };
  }
}
